<template>
  <div class="export" @mousemove="googleTranslateElementInit" v-if="assinaturas.homologacao[0].status === 2" >
    <div v-if="is_loading">
      <LoadingTranslation />
    </div>
    <body>

      <!-- <div class="btnTranslate">
        <img src="img/icon-googleT.png" alt="" />
        <p>Traduzir</p>
      </div> -->
      <div id="google_translate_element"></div>

      <page class="page-person" size="A4">
        <!-- AMARANDO CABEÇALHO E CORPO  -->
        <div>
          <!-- CABEÇALHO -->
          <Cabecalho :codigo_rrim="data.InforGeral.ID" />
          <!-- MAIN -->
          <main>
            <!-- INFORMAÇÕES GERAIS -->
            <InforGeral :dataInforGeral="data.InforGeral" />
            <!-- PRODUTO -->
            <Produtos :dataProdutos="data.Produtos" />

            <!-- CAVIDADE -->
            <Cavidade :dataMoldeAberto="data.MoldeAberto" />

            <!-- INFOR GERAL DE MOLDE -->
            <InforGeralMolde :dataMoldeFechado="data.MoldeFechado" />

            <!-- CHECK-LIST ENGENHARIA / FERRAMENTARIA -->
            <Checklist :DataChecklist="data.MoldeFechado.Checklist" />
          </main>

          <!-- FOOTER -->
        </div>
        <!--  -->
        <footer>
          <Assinaturas :id="data.InforGeral.ID" />
          <FooterImpresso />
        </footer>
      </page>

      <page class="page-person" size="A4">
        <!-- AMARRANDO CABEÇALHO E CORPO  -->
        <div>
          <!-- CABEÇALHO -->
          <Cabecalho :codigo_rrim="data.InforGeral.ID" />
          <!-- MAIN -->
          <main>
            <AberturaDeEmbalagemImgs :data="data.ImagesRRIM" />
            <MoldeFechadoImgs :data="data.ImagesRRIM" />
            <MoldeAbertoImgs :data="data.ImagesRRIM" />
            <!--  -->
          </main>

          <!-- FOOTER -->
        </div>
        <!--  -->
        <footer>
          <FooterImpresso />
        </footer>
      </page>

      <page class="page-person" size="A4">
        <!-- AMARANDO CABEÇALHO E CORPO  -->
        <div>
          <!-- CABEÇALHO -->
          <Cabecalho :codigo_rrim="data.InforGeral.ID" />
          <!-- MAIN -->
          <main>
            <ListaDeSpareParts :data="data.ListSpareParts" />
            <!--  -->
          </main>

          <!-- FOOTER -->
        </div>
        <!--  -->
        <footer>
          <FooterImpresso />
        </footer>
        <div class="btnImprimir">
          <button @click="printDocument">Imprimir</button>
        </div>
      </page>
    </body>
  </div>
  <div v-else>
    Exportação não disponivel
  </div>
</template>

<script>
import Cabecalho from "./modules/page_rrim/cabecalho.vue";
import InforGeral from "./modules/page_rrim/informacoes_gerais.vue";
import Produtos from "./modules/page_rrim/produtos.vue";
import Cavidade from "./modules/page_rrim/cavidade.vue";
import InforGeralMolde from "./modules/page_rrim/informacoes_gerais_molde.vue";
import Checklist from "./modules/page_rrim/checklist.vue";
import Assinaturas from "./modules/page_rrim/assinaturas.vue";
import FooterImpresso from "./modules/page_rrim/FooterImpresso.vue";
//FOYOS
import AberturaDeEmbalagemImgs from "./modules/page_images_rrim/abertura _de_embalagem.vue";
import MoldeFechadoImgs from "./modules/page_images_rrim/molde_fechado.vue";
import MoldeAbertoImgs from "./modules/page_images_rrim/molde_aberto.vue";
//Lista de Spare Parts
import ListaDeSpareParts from "./modules/page_lsp/lista_SpareParts.vue";
import { FindRRimHomologada } from "../../controllers/RRIM/FindRRimHomologada";

import { GetFindDataRRIM } from "../../controllers/RRIM/GetFindDataRRIM";
import LoadingTranslation from "../LoadingTranslation.vue";
import axios from "axios";

export default {
  name: "exportRRIM",
  components: {
    Cabecalho,
    InforGeral,
    ListaDeSpareParts,
    Produtos,
    Cavidade,
    InforGeralMolde,
    Checklist,
    Assinaturas,
    AberturaDeEmbalagemImgs,
    MoldeFechadoImgs,
    MoldeAbertoImgs,
    FooterImpresso,
    LoadingTranslation,
  },

  async created() {
    let id = this.$route.query.id;
    if (id > 0) {
      const res = await GetFindDataRRIM(id);
      this.data = res.data.DataRRIM;
      this.assinaturas = await FindRRimHomologada(this.data.InforGeral.ID);

      
    }
  },
  data() {
    return {
      data: "",
      assinaturas: null,
    };
  },
  mounted() {
    this.googleTranslateElementInit();
  },
  methods: {
    googleTranslateElementInit() {
      new google.translate.TranslateElement(
        { pageLanguage: "pt", includedLanguages: "pt,en" },
        "google_translate_element"
      );
    },
    printDocument() {
      window.print();
    },
  },
};
</script>

<style >
* {
  margin: 0;
  box-sizing: 0;
  padding: 0;
  font-family: Arial, Helvetica, sans-serif;
}

/*google translate Dropdown */

#google_translate_element select {
  background: #ffffff;
  color: #474747;
  border: none;
  border-radius: 3px;
  padding: 6px 8px;
  box-shadow: rgb(50 50 93 / 25%) 0px 6px 12px -2px,
    rgb(0 0 0 / 30%) 0px 3px 7px -3px;
}

/*google translate link | logo */
.goog-logo-link {
  display: none !important;
}
.goog-te-gadget {
  color: transparent !important;
}

/* google translate banner-frame */

.goog-te-banner-frame {
  display: none !important;
}

#goog-gt-tt,
.goog-te-balloon-frame {
  display: none !important;
}
.goog-text-highlight {
  background: none !important;
  box-shadow: none !important;
}

#google_translate_element {
  position: fixed;
  top: 6rem;
  left: 0.5rem;
}

.btnTranslate {
  top: 3rem;
  position: fixed;
  width: fit-content;
  height: 2rem;
  align-items: center;
  gap: 0.3rem;
  justify-content: center;
  display: flex;
  background: var(--white);
  font-weight: 700;
  border-radius: 0.2rem;
  padding: 0 1rem;
  margin: 0.5rem;
  cursor: pointer;
  box-shadow: rgba(50, 50, 93, 0.25) 0px 6px 12px -2px,
    rgba(0, 0, 0, 0.3) 0px 3px 7px -3px;
}
.btnTranslate:hover {
  filter: brightness(0.6);
}
.btnTranslate img {
  width: 1rem;
  height: fit-content;
}
.btnTranslate span {
  width: 50px;
  height: 50px;
  line-height: 50px;
  padding: 0.5rem;
  background: color("b-gray");
  border-radius: 5px;
  cursor: pointer;
}

.export page {
  background: var(--white);
  display: block;
  margin: 0 auto;
  margin-bottom: 2cm;
  box-shadow: 0 0 0.5cm rgba(0, 0, 0, 0.5);
}

.export page[size="A4"] {
  width: 21cm;
  min-height: 27.55cm;
  display: flex;
  flex-direction: column;
  padding: 2rem;
}

.page-person {
  justify-content: space-between;
}

.export main {
  height: 100%;
}

.export .btnImprimir button {
  width: 15%;
  padding: 0.5rem;
  font-size: 1rem;
  font-weight: 600;
  letter-spacing: 0.2rem;
  cursor: pointer;
  border-radius: 1rem;
  border: none;
  background: #b1b1b1;
  box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
}

.export .btnImprimir button {
  width: 15%;
  padding: 0.5rem;
  font-size: 1rem;
  font-weight: 600;
  letter-spacing: 0.2rem;
  cursor: pointer;
  border-radius: 1rem;
  border: none;
  background: #b1b1b1;
  box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
}

@media print {
  .btnTranslate,
  #google_translate_element {
    display: none;
  }
  .export body,
  .export page {
    margin: 0;
    box-shadow: none;
    background: var(--white);
  }

  .export page {
    page-break-inside: avoid;
    border: 1px solid var(--black);
  }

  .btnImprimir button {
    display: none;
  }

  .export page[size="A4"] {
    width: 100vw;
  }
}

/* Categorias */

.categorias {
  width: 100%;
  height: 30px;
  display: flex;
  padding: 0 1rem;
  align-items: center;
  font-size: 1rem;
  border-top: 2px solid #636363;
  border-bottom: 2px solid #636363;
  color: #636363;
  font-weight: 600;
}

.sub-categorias {
  width: 100%;
  height: 20px;
  background: var(--red);
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 13px;
  background: var(--grayBody);
  /* #92D050; */
}

/* Fim categorias */

/*  Rodape de assinaturas */
.assinaturas {
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
}

.assinaturas .items {
  display: flex;
}

.assinaturas .items div {
  display: flex;
  justify-content: center;
  width: 100%;
}

.export footer .assinaturas .items .m75,
.items .m75 {
  width: 100%;
}

.items .items-row .m25 {
  width: 25%;
}

.assinaturas .items .assinatura {
  height: 100%;
}

.assinaturas .items .campos {
  align-items: center;
}

/* Rodapé de Assinaturas */
/* MAIN */
/*  */
.m25,
.items .m25 {
  width: 125%;
}

.items {
  display: flex;
  justify-content: center;
  width: auto;
  height: auto;
  background: var(--white);
  font-size: 12px;
  text-align: center;
}

.items div {
  width: 100%;
}

.items-row {
  display: flex;
  width: 100%;
  height: 16%;
  background: var(--white);
  font-size: 12px;
  align-items: center;
  justify-content: center;
}

.items-row div {
  width: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
}

.item-title {
  background: #ededed;
  padding: 0.3rem;
}

/* MAIN - INFORMAÇÕES GERAIS DO MOLDE */
.infor-geral-molde div .row {
  display: flex;
  flex-direction: row;
}

.infor-geral-molde .items-columm {
  display: flex;
  justify-content: center;
  width: 100%;
  height: 16%;
  background: var(--white);
  font-size: 12px;
  text-align: center;
  display: flex;
  flex-direction: column;
}

/* MAIN - CHECKLIST */
.checklist-eng .items table {
  width: 100%;
  font-size: 11px;
  border-collapse: collapse;
  border-spacing: 0;
}

.checklist-eng .items table tbody th {
  /* display: flex; */
  padding-left: 2px;
  min-width: 26vh;
}

.checklist-eng .items table tbody tr {
  /* display: flex; */
  text-align: left;
  border-top: 1px solid var(--black);
}

.checklist-eng .items table tbody tr td {
  padding-top: 3px;
  padding-right: 3px;
}

.checklist-eng .items table {
  width: 100%;
  font-size: 10px;
}

/*CLASS BORDER */
.bd-top {
  border-top: 1px solid #636363;
}

.bd-bottom {
  border-bottom: 1px solid #636363;
}

.bd-right {
  border-right: 1px solid #636363;
}

.margin-mn {
  padding-left: 5px;
  align-items: flex-start;
}

.items-row-img {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  /* padding: 10px 0px; */
}

.img-exp {
  /* min-height: 90.66px; */
  /* padding: 4px 10px; */
  display: flex;
  flex-direction: column;
  margin-top: 4px;
  /* border: 1px solid; */
}

.img-exp .conteudo img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.img-exp .conteudo {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 4.68cm;
  height: 5.42cm;
  color: #636363;
}

.img-exp .legenda {
  /* padding: 5px; */
  border-top: 1px solid #636363;
  font-size: 11px;
  display: flex;
  justify-content: center;
}

.spare-parts table tbody img {
  width: 100%;
}

.spare-parts table tbody td .img-exp {
  width: 4.42cm;
  height: 3.68cm;
}

.spare-parts table tbody td {
  /* display: flex; */
  /* flex-direction: column; */

  text-align: center;
  justify-content: center;
}

.spare-parts table {
  width: 100%;
}

.td-center {
  display: flex;
  justify-content: center;
}

.alert-sp {
  color: var(--red);
  border: 2px solid var(--red);
  height: 30px;
  width: 90%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.main-sp {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.main-alert {
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
